
import { Component, Vue } from 'vue-property-decorator'
import { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import { Pagination } from '@/components/common/organisms/PaginationButton.vue'

export type MarkersData = {
  nickname: string
  subjects: string[]
  subjectNames: string[]
}

export type MarkerSearchQuery = {
  bcbtCode?: string
  nickname?: string
  subjectCode?: string
}

export type MarkersObject = {
  pagination: Pagination
  responses: MarkersData[]
}

const MAX_SUBJECT_COUNT = 5 // 全教科数

@Component
export default class MarkerListApis extends Vue {
  private selection: SelectOption[] = []

  /**
   * 検索プルダウン・チェックボックス用 教科一覧取得
   */
  protected async loadSubjectsApi(studyContentId?: number): Promise<SelectOption[]> {
    const { data } = await Vue.prototype.$http.httpWithToken.get('/v1/subjects', {
      params: { studyContentId: studyContentId },
    })

    return data.map((obj: { id: number; code: string; name: string; sortNum: number }) => {
      return {
        value: obj.code,
        text: obj.name,
      }
    })
  }

  /**
   * 検索プルダウン・チェックボックス用教科取得
   */
  protected async subjectNameList(): Promise<SelectOption[]> {
    let data: SelectOption[] = await this.loadSubjectsApi()
    return data
  }

  /**
   * 教科名成形
   */
  private subjectNames(markersObject: MarkersObject): MarkersObject {
    markersObject.responses.forEach((markersData: MarkersData) => {
      if (markersData.subjectNames.length == MAX_SUBJECT_COUNT) {
        markersData.subjectNames.splice(0)
        markersData.subjectNames[0] = '全教科'
      } else {
        let subjectNames = markersData.subjectNames.join('・')
        markersData.subjectNames.splice(0)
        markersData.subjectNames[0] = subjectNames
      }
    })
    return markersObject
  }

  /**
   * 採点者一覧取得
   * get(`v1/admin/marker/index?page=${page}`)
   */
  protected async markersListApi(page: number): Promise<MarkersObject> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`v1/admin/marker/index?page=${page}`)
    const markersObject = this.subjectNames(data)
    return markersObject
  }

  /**
   * 採点者検索結果取得
   * get(`v1/admin/marker/search?page=${page}`, { params })
   */
  protected async searchMarkersApi(page: number, markerSearchQuery: MarkerSearchQuery): Promise<MarkersObject> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`v1/admin/marker/search?page=${page}&`, {
      params: markerSearchQuery,
    })
    const markersObject = this.subjectNames(data)
    return markersObject
  }

  /**
   * 採点者追加
   * post('/v1/admin/markers', { nickname, password, subjectCodes})
   */
  protected async markerAdminAddApi(nickname: string, password: string, subjectCodes: string[]): Promise<void> {
    await Vue.prototype.$http.httpWithToken.post('/v1/admin/markers', {
      nickname: nickname,
      password: password,
      subjectCodes: subjectCodes,
    })
  }

  /**
   * 氏名変更
   * patch(`/v1/admin/marker/${bcbtCode}`, { nickname })
   */
  protected async userNicknameUpdateApi(bcbtCode: string, nickname: string): Promise<void> {
    await Vue.prototype.$http.httpWithToken.patch(`/v1/admin/marker/${bcbtCode}`, { nickname: nickname })
  }

  /**
   * 教科変更
   * patch(`/v1/admin/marker/${bcbtCode}`, { subjectCodes })
   */
  protected async markerSubjectUpdateApi(bcbtCode: string, subjectCodes: string[]): Promise<void> {
    await Vue.prototype.$http.httpWithToken.patch(`/v1/admin/marker/${bcbtCode}`, { subjectCodes: subjectCodes })
  }

  /**
   * パスワード変更
   * patch(`/v1/admin/marker/${bcbtCode}`, { password, comfirmPassword })
   */
  protected async userPasswordUpdateApi(bcbtCode: string, password: string, comfirmPassword: string): Promise<void> {
    await Vue.prototype.$http.httpWithToken.patch(`/v1/admin/marker/${bcbtCode}`, {
      password: password,
      comfirmPassword: comfirmPassword,
    })
  }

  /**
   * ユーザー削除
   * delete(`/v1/user/${bcbtCode}`)
   */
  protected async userDeleteApi(bcbtCode: string): Promise<void> {
    await Vue.prototype.$http.httpWithToken.delete(`/v1/user/${bcbtCode}`)
  }
}
